import { render } from "./ProductPlatformsTabs.vue?vue&type=template&id=1e01f8be&scoped=true"
import script from "./ProductPlatformsTabs.vue?vue&type=script&lang=js"
export * from "./ProductPlatformsTabs.vue?vue&type=script&lang=js"

import "./ProductPlatformsTabs.vue?vue&type=style&index=0&id=1e01f8be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e01f8be"],['__file',"webpack-assets/vue/templates/product/catalog/parts/ProductPlatformsTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e01f8be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e01f8be', __exports__)) {
    api.reload('1e01f8be', __exports__)
  }
  
  module.hot.accept("./ProductPlatformsTabs.vue?vue&type=template&id=1e01f8be&scoped=true", () => {
    api.rerender('1e01f8be', render)
  })

}


export default __exports__